import { Collapse, Flex } from "@/atoms"
import { BodyCollapse, LabelCollapse, TagFlow } from "."

import styles from "./Flow.module.scss"

import type { FlowProps } from "."

export const Flow = (props: FlowProps) => {
  const { items, isFalsePositive } = props

  return (
    <Flex vertical className={styles.wrapper}>
      {items.map((item, itemIndex) => {
        const { number, shortName, line, file, roles, children } = item
        const maxIndex = items.length - 1
        const rootActiveKey = "root"
        const isLast = maxIndex === itemIndex
        const isStart = itemIndex === 0

        return (
          <Collapse
            ghost
            key={itemIndex}
            prefixCls="root-collapse-data-flow"
            className={styles.collapseRoot}
            activeKey={rootActiveKey}
            expandIcon={() => null}
            bordered={false}
            items={[
              {
                key: rootActiveKey,
                children: (
                  <Collapse
                    ghost
                    bordered={false}
                    expandIconPlacement="end"
                    items={[
                      {
                        key: itemIndex,
                        className: styles.collapseItemRoot,
                        label: (
                          <LabelCollapse
                            isFalsePositive={isFalsePositive}
                            start={isStart}
                            end={isLast}
                            value={number}
                            title={shortName}
                            description={file}
                            line={line}
                            variant="primary"
                            extra={roles.map((role) => (
                              <TagFlow key={role} type={role.toLowerCase()} />
                            ))}
                          />
                        ),
                        children: <BodyCollapse item={item} />
                      },
                      ...(children || []).map((child, childIndex) => {
                        const key = `${itemIndex}-${childIndex}`

                        return {
                          key,
                          className: styles.collapseItemNested,
                          label: (
                            <LabelCollapse
                              title={child.shortName}
                              description={child.file}
                              line={child.line}
                              variant="primary"
                              extra={child.roles.map((role: string) => (
                                <TagFlow key={role} type={role.toLowerCase()} />
                              ))}
                            />
                          ),
                          children: <BodyCollapse item={child} />
                        }
                      })
                    ]}
                  />
                )
              }
            ]}
          />
        )
      })}
    </Flex>
  )
}
